import { render } from "./MenuSiModuleAffiliate.vue?vue&type=template&id=eb661aa0&scoped=true"
import script from "./MenuSiModuleAffiliate.vue?vue&type=script&lang=js"
export * from "./MenuSiModuleAffiliate.vue?vue&type=script&lang=js"

import "./MenuSiModuleAffiliate.vue?vue&type=style&index=0&id=eb661aa0&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb661aa0"]])

export default __exports__